/** Number and copy helpers for the intro. Pure, so they test without a DOM. */

export const int = (n: number): string => Math.round(n).toLocaleString('en-US');

export const fixed = (n: number, digits = 1): string => n.toFixed(digits);

/** "+0.4" / "-0.8" / "0.0": the sign is part of the claim, so it is always printed. */
export function signed(n: number, digits = 1): string {
  const body = Math.abs(n).toFixed(digits);
  if (Number(body) === 0) return body;
  return `${n > 0 ? '+' : '-'}${body}`;
}

export const percent = (n: number, digits = 0): string => `${n.toFixed(digits)}%`;

/** A share (0-1) as a percentage, with a decimal only where it carries information. */
export function share(n: number): string {
  const p = n * 100;
  return `${p < 10 ? p.toFixed(1) : Math.round(p)}%`;
}

/** The headline for a percentile: the figure riders actually want, never "0%". */
export function topPercent(percentile: number): number {
  return Math.min(99, Math.max(1, Math.round(percentile)));
}

export function days(hours: number): string {
  const d = hours / 24;
  return d >= 10 ? int(d) : d.toFixed(1);
}

/** The English word for how a delta compares with the community. */
export function graderWord(delta: number): string {
  if (delta <= -1) return 'A TOUGH GRADER';
  if (delta < -0.25) return 'A LITTLE STRICT';
  if (delta <= 0.25) return 'RIGHT ON THE CROWD';
  if (delta < 1) return 'A LITTLE GENEROUS';
  return 'A GENEROUS GRADER';
}
